import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (
  currentPage,
  perPage,
  searchDateFrom,
  searchStore,
  name,
  contact_no,
  id,
  onlyWin,
  type
) => {

  return await GET(
    `/admin/matka/played-game?page=${currentPage || 1}&per_page=${perPage || 10}&name=${name || ""}&contact_no=${contact_no || ""}&from=${searchDateFrom || ""}&store_id=${searchStore || ""}&id=${id || ""}&only_win=${onlyWin || ''}&type=${type || ''}`, {}, process.env.REACT_APP_MATKA_BASE_URL
  );
};

export const deleteBet = async (id) => {
  return await POST(`/admin/matka/delete-bet/${id}`, {}, process.env.REACT_APP_MATKA_BASE_URL);
}

export const editBet = async (id,data) => {
  return await POST(`/admin/matka/edit-bet/${id}`, data, process.env.REACT_APP_MATKA_BASE_URL);
}

